module.exports = __webpack_public_path__ + "img/devise.e551db7f.png";